import { c as _c } from "react-compiler-runtime";
import { useState } from 'react';
import { COMMENT_LIST_PADDING_PX } from '../../../constants/sidebar';
const COMMENTER_FORM_HEIGHT = 190;
const EMPTY_COMMENTER_HEIGHT = COMMENTER_FORM_HEIGHT + COMMENT_LIST_PADDING_PX * 2;
export default function useMiniCommenterSize() {
  "use memo";

  const $ = _c(2);
  const [miniCommenterSize, setMiniCommenterSize] = useState(EMPTY_COMMENTER_HEIGHT);
  const [minHeightForPopover, setMinHeightForPopover] = useState(0);
  const t0 = Math.max(miniCommenterSize, minHeightForPopover);
  let t1;
  if ($[0] !== t0) {
    t1 = {
      miniCommenterSize: t0,
      setMinHeightForPopover,
      onResizeMiniCommenter: setMiniCommenterSize
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}